import { create } from "zustand";

export const trackingMap = create((set) => ({
  booking: undefined,
  setBooking: (booking) => {
    set((state) => ({ ...state, booking }));
  },
  
}));
